<template>
  <div class="contacts">
    <b-container>
      <h3 class="display-4 page-title text-center mb-4">Contatti</h3>
      <h2 class="page-subtitle text-center">
        Richiesta informazioni
      </h2>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur
        adipiscing elit.
      </p>
    </b-container>
  </div>
</template>

<style lang="scss">
.contacts {
    padding: 2rem 0;
}
</style>

<script>
export default {
  name: "Contacts",
};
</script>